// frontend/src/components/Layout/QuickBookingLayout.tsx
// Dedicated layout for quick booking pages - mobile-first design

import React from 'react';

import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

interface QuickBookingLayoutProps {
  children: React.ReactNode;
  className?: string;
  showProgress?: boolean;
  currentStep?: number;
  totalSteps?: number;
}

const QuickBookingLayout: React.FC<QuickBookingLayoutProps> = ({ 
  children, 
  className = '',
  showProgress = false,
  currentStep = 1,
  totalSteps = 3
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      
      {/* Header - Minimal variant for cleaner booking experience */}
      <PublicHeader variant="full" showAuthButtons={true} />
      
      {/* Progress Bar (Optional) */}
      {showProgress && (
        <div className="bg-white border-b border-gray-200 px-4 py-3">
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center justify-between text-sm text-gray-600 mb-2">
              <span>Step {currentStep} of {totalSteps}</span>
              <span>{Math.round((currentStep / totalSteps) * 100)}% Complete</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div 
                className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                style={{ width: `${(currentStep / totalSteps) * 100}%` }}
              ></div>
            </div>
          </div>
        </div>
      )}

      {/* Main Content Area */}
      <main className={`flex-1 ${className}`}>
        {/* Mobile-first container with responsive padding */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          {children}
        </div>
      </main>

      {/* Footer - Minimal variant for booking pages */}
      <PublicFooter variant="full" />

    </div>
  );
};

export default QuickBookingLayout;